export default __webpack_public_path__ + "static/media/login-bg-4.4933ed15.png";